import React from 'react';
import { useParams } from 'react-router-dom';

import SvgHist from './demos/SvgHist';
import D3PieChart from './demos/D3PieChart';
import FractalBinaryTree from './demos/FractalBinaryTree';
import Rft from './demos/Rft'; 

const Demo = () => {
  const { id } = useParams();

  return (
    <div className="mx-auto my-20 min-h-screen p-12">
      {id === 'svg-draw-histogram' && <SvgHist />}
      {id === 'd3-histogram' && <D3PieChart />}
      {id === 'fractal-binary-tree' && <FractalBinaryTree />}
      {id === 'rft' && <Rft />}
    </div>
  )
}

export default Demo;
